<template>
  <b-img :src="logo" :width="width" />
</template>

<script>
import Logo from '@/assets/willis-logo.svg'

export default {
  props: {
    height: {
      type: String,
      default: () => '20'
    },
    width: {
      type: String,
      default: () => '100'
    }
  },

  data() {
    return {
      logo: Logo
    }
  }
}
</script>
